export const tileStyles = {
  height: 290,
  borderColor: '#ccc',
  borderRadius: 3,
  width: 200,
};

export const quickViewButtonStyles = {
  color: '#3E7697',
  position: 'absolute',
  bottom: 0,
  fontSize: '1.2rem',
  backgroundColor: 'inherit',
  borderTop: 'solid 1px #ccc',
  width: 146,
};

// eslint-disable-next-line max-len
export const GHOST_BTN_BASE_OVERRIDE = 'sui-btn sui-btn-ghost sui-btn-ghost-focus sui-font-normal sui-text-base sui-leading-normal sui-tracking-normal sui-normal-case sui-line-clamp-none';
export const INACTIVE_GHOST_BTN_OVERRIDE = `${GHOST_BTN_BASE_OVERRIDE} sui-btn-ghost-inactive`;
export const ACTIVE_GHOST_BTN_OVERRIDE = `${GHOST_BTN_BASE_OVERRIDE} sui-btn-ghost-active`;
